import { storage } from './storage.js';

/**
 * Aparência do app (Conta › Aparência): Automático (segue o celular), Claro ou Escuro.
 * A escolha fica só no aparelho. O tema escuro liga a classe .ion-palette-dark no <html>
 * (paleta do Ionic + tokens --tc-* em theme/variables.css).
 */
const KEY = 'tc.appearance';
const media = matchMedia('(prefers-color-scheme: dark)');
export const APPEARANCES = [
  { key: 'auto', label: 'Automático' },
  { key: 'light', label: 'Claro' },
  { key: 'dark', label: 'Escuro' },
];

function apply() {
  const pref = theme.preference;
  const dark = pref === 'dark' || (pref === 'auto' && media.matches);
  const root = document.documentElement;
  root.classList.toggle('ion-palette-dark', dark);
  root.style.colorScheme = dark ? 'dark' : 'light';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#0b0e14' : '#f4f6f9');
}

export const theme = {
  /** @returns {'auto' | 'light' | 'dark'} */
  get preference() {
    const v = storage.get(KEY);
    return v === 'light' || v === 'dark' ? v : 'auto';
  },
  set(pref) {
    if (pref === 'auto') storage.remove(KEY);
    else storage.set(KEY, pref);
    apply();
  },
  get isDark() {
    return document.documentElement.classList.contains('ion-palette-dark');
  },
  init() {
    apply();
    media.addEventListener?.('change', apply);
  },
};
